/**
 * Popup "aggiungi anche" dopo l'aggiunta al carrello (22/09/2026).
 *
 * Perche' esiste: il popup della consegna (atc-choice-popup.js) esce solo sui
 * prodotti con servizi al piano, cioe' i grandi elettrodomestici. Su tutto il
 * resto, dopo l'aggiunta al carrello, non succede niente: qui si propongono tre
 * prodotti nostri, a scaffale, che partono nello stesso pacco.
 *
 * Regole decise con Danilo (22/09):
 *  - la lista la cura marketing nella promo "spinta-carrello" (collection
 *    promo-spinta-carrello): sono sempre e solo prodotti in casa;
 *  - il blocco esce se nel carrello c'e' almeno un prodotto che parte dal
 *    nostro magazzino; se partono tutti in dropship no, perche' lo sfizio
 *    farebbe nascere un collo in piu' (regola aggiornata da Danilo il 24/09).
 *    La lista degli id in dropship la scrive ogni mattina alle 06:20 il batch spinta-carrello su
 *    photo.yeppon.it, in un file col giorno nel nome (drop-products-AAAAMMGG.json):
 *    ImageKit tiene in cache i file per un anno e ignora il Cache-Control, quindi
 *    un nome fisso resterebbe quello del primo giorno per sempre;
 *  - se quella lista non si carica il popup non esce: meglio non proporre che
 *    proporre una spedizione in piu';
 *  - dove esce il popup della consegna qui non si fa niente: o l'uno o l'altro;
 *  - niente "una volta per sessione": era la regola del popup, ma il blocco
 *    sta fermo nel cassetto e nella pagina carrello, non interrompe nessuno, e
 *    chi lo vede nel cassetto deve ritrovarlo anche nel carrello (Danilo, 24/09).
 *
 * Aggancio: si osservano le chiamate a /cart/add.js gia' fatte dal tema, come fa
 * warranty-upsell.js. Non si intercetta il submit, cosi' non si litiga con gli
 * altri script: il prodotto entra nel carrello e solo dopo si apre il popup.
 *
 * Prova su staging: localStorage.setItem('yeppon_push_test','1') salta il
 * controllo dropship (serve finche' il file sul CDN non esiste).
 */
(function () {
  'use strict';
  if (window.__pushPopup) return;

  // In prova si possono cambiare da console: window.__pushPopupLista / __pushPopupDrop
  var URL_LISTA = window.__pushPopupLista || '/collections/promo-spinta-carrello/products.json?limit=30';
  var BASE_DROP = 'https://photo.yeppon.it/data/drop-products-';
  var QUANTI = 12;          // quanti prodotti nel carosello, al massimo

  var mioAdd = false;   // vero mentre aggiungo io: non devo rispondere a me stesso
  var aperto = false;
  var promessaLista = null;
  var promessaDrop = null;

  // Prova con un link solo: ?push_prova=1 accende la modalita' di prova e, finche'
  // la promo non esiste, usa le Offerte del giorno come lista. Vale solo sui temi
  // non pubblicati (anteprima), mai sul sito vero.
  try {
    var qp = new URLSearchParams(location.search);
    var temaVivo = window.Shopify && Shopify.theme && Shopify.theme.role === 'main';
    if (!temaVivo && qp.get('push_prova') === '1') {
      localStorage.setItem('yeppon_push_test', '1');
      sessionStorage.removeItem('yeppon_push_popup_visto');
      if (!window.__pushPopupLista) window.__pushPopupLista = '/collections/promo-offerte-del-giorno/products.json?limit=30';
    }
    if (qp.get('push_prova') === '0') localStorage.removeItem('yeppon_push_test');
  } catch (e) {}

  function inProva() {
    try { return localStorage.getItem('yeppon_push_test') === '1'; } catch (e) { return false; }
  }

  function idProdotto(handle) {
    var pezzo = String(handle || '').split('-').pop();
    return /^\d+$/.test(pezzo) ? pezzo : '';
  }

  function euro(centesimi) {
    try {
      return (centesimi / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return (centesimi / 100).toFixed(2) + ' €';
    }
  }

  function traccia(nome, dati) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(nome, dati || {});
    } catch (e) {}
  }

  // Gli id dei prodotti che partono in dropship: il popup non esce su quelli.
  // Il file di oggi c'e' dalle 06:20; prima, o se il batch ha saltato un giro,
  // va bene quello di ieri o di ieri l'altro: la lista cambia poco.
  function urlDrop(giorniFa) {
    var d = new Date();
    d.setDate(d.getDate() - giorniFa);
    var mm = ('0' + (d.getMonth() + 1)).slice(-2);
    var gg = ('0' + d.getDate()).slice(-2);
    return BASE_DROP + d.getFullYear() + mm + gg + '.json';
  }

  function scaricaDrop(url) {
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (dati) {
        var arr = dati && dati.drop ? dati.drop : dati;
        if (!Array.isArray(arr)) return null;
        var set = {};
        for (var i = 0; i < arr.length; i++) set[String(arr[i])] = 1;
        return set;
      })
      .catch(function () { return null; });
  }

  function listaDrop() {
    if (!promessaDrop) {
      if (window.__pushPopupDrop) {
        promessaDrop = scaricaDrop(window.__pushPopupDrop);
      } else {
        promessaDrop = scaricaDrop(urlDrop(0)).then(function (set) {
          return set || scaricaDrop(urlDrop(1));
        }).then(function (set) {
          return set || scaricaDrop(urlDrop(2));
        });
      }
    }
    return promessaDrop;
  }

  function listaPromo() {
    if (!promessaLista) {
      promessaLista = fetch(window.__pushPopupLista || URL_LISTA, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }
    return promessaLista;
  }

  // Aggiunta al carrello con XMLHttpRequest: le fetch verso /cart/add le
  // intercetta warranty-upsell.js, che le trattiene finche' il cliente non
  // risponde al suo popup. Qui serve una chiamata che parta e basta.
  function aggiungiAlCarrello(variante) {
    return new Promise(function (ok, ko) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () { (xhr.status >= 200 && xhr.status < 300) ? ok(xhr.responseText) : ko(xhr.status); };
      xhr.onerror = function () { ko('rete'); };
      xhr.send(JSON.stringify({ items: [{ id: variante, quantity: 1 }] }));
    });
  }

  function carrello() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  function scegli(prodotti, carrelloAttuale, handleAggiunto) {
    var dentro = {};
    (carrelloAttuale.items || []).forEach(function (i) { dentro[i.handle] = 1; });
    dentro[handleAggiunto] = 1;

    var out = [];
    for (var i = 0; i < prodotti.length && out.length < QUANTI; i++) {
      var p = prodotti[i];
      if (dentro[p.handle]) continue;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) continue;
      out.push({
        handle: p.handle,
        titolo: p.title,
        prezzo: Math.round(parseFloat(v.price) * 100),
        variante: v.id,
        foto: (p.images && p.images[0] && p.images[0].src) || ''
      });
    }
    return out;
  }

  // --- carosello nel cassetto e nella pagina carrello -----------------------
  // Un carosello orizzontale di schede. Nel cassetto sta DENTRO la parte che
  // scorre, dopo i prodotti e la garanzia; nella pagina carrello dopo il form.
  // Il posto lo disegna gia' il tema (snippet cart-push-posto: scheletro grigio
  // con le stesse misure) e lo stile e' nel <head> (snippet cart-push-style):
  // qui lo scheletro si riempie oppure si toglie, e la pagina non salta.

  var proposte = null;     // le scelte, tenute per rimetterle dopo un ridisegno
  var osservatore = null;

  // Il posto disegnato dal tema (scheletro) nella zona giusta: nel cassetto o
  // nella pagina carrello, che ha comunque anche il cassetto, nascosto.
  function postoIn(paginaCarrello) {
    return Array.prototype.filter.call(document.querySelectorAll('[data-app-push-posto]'), function (el) {
      return paginaCarrello ? !el.closest('#CartDrawer') : !!el.closest('#CartDrawer');
    })[0] || null;
  }

  // Niente da proporre (solo drop, lista vuota, file dei drop mancante): via gli
  // scheletri, altrimenti resterebbero grigi.
  function togliPosti() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-app-push-posto]'), function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function esc(t) {
    return String(t || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function fotoPiccola(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }

  function caroselloHtml(scelti) {
    return '<div class="app-push__h"><div>' +
        '<p class="app-push__t">Aggiungi al tuo ordine</p>' +
        '<p class="app-push__s">Dal nostro magazzino, nello stesso pacco.</p>' +
      '</div><div class="app-push__nav">' +
        '<button type="button" data-app-nav="-1" aria-label="Precedenti">&lsaquo;</button>' +
        '<button type="button" data-app-nav="1" aria-label="Successivi">&rsaquo;</button>' +
      '</div></div>' +
      '<div class="app-push__track">' +
      scelti.map(function (p, i) {
        var link = '/products/' + p.handle;
        return '<div class="app-push__c">' +
          '<a class="app-push__img" href="' + link + '">' +
            (p.foto ? '<img src="' + esc(fotoPiccola(p.foto)) + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<a class="app-push__n" href="' + link + '">' + esc(p.titolo) + '</a>' +
          '<span class="app-push__p">' + euro(p.prezzo) + '</span>' +
          '<button type="button" class="app-push__b" data-app-add="' + i + '">Aggiungi</button>' +
          '</div>';
      }).join('') +
      '</div>';
  }

  // Frecce solo dove c'e' un mouse; col dito si scorre. Spente agli estremi.
  function collegaFrecce(box) {
    var pista = box.querySelector('.app-push__track');
    var frecce = box.querySelectorAll('[data-app-nav]');
    if (!pista || frecce.length < 2) return;
    function aggiorna() {
      frecce[0].disabled = pista.scrollLeft <= 2;
      frecce[1].disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    }
    Array.prototype.forEach.call(frecce, function (f) {
      f.addEventListener('click', function () {
        var passo = Math.max(pista.clientWidth - 40, 140);
        pista.scrollBy({ left: passo * parseInt(f.getAttribute('data-app-nav'), 10), behavior: 'smooth' });
      });
    });
    pista.addEventListener('scroll', aggiorna, { passive: true });
    setTimeout(aggiorna, 0);
  }

  function collegaClic(box, scelti) {
    box.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-app-add]') : null;
      if (!b) return;
      var p = scelti[parseInt(b.getAttribute('data-app-add'), 10)];
      if (!p) return;
      b.disabled = true;
      b.textContent = 'Aggiungo…';
      mioAdd = true;
      aggiungiAlCarrello(p.variante)
        .then(function () {
          b.textContent = 'Aggiunto';
          traccia('Push Carrello Add', { prodotto: p.handle, prezzo: p.prezzo / 100 });
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: 'EUR',
                value: p.prezzo / 100,
                items: [{ item_id: idProdotto(p.handle), item_name: p.titolo, price: p.prezzo / 100, quantity: 1,
                          item_list_name: 'Aggiungi anche (carrello)' }]
              },
              event_id: 'atc_push_' + Date.now()
            });
          } catch (e2) {}
          ridisegnaCarrello();
        })
        .catch(function () { b.disabled = false; b.textContent = 'Riprova'; })
        .then(function () { mioAdd = false; });
    });
  }

  function inserisci() {
    if (!proposte || !proposte.length) return false;
    if (document.querySelector('[data-app-push]')) return true;
    // Sempre subito dopo l'elenco dei prodotti: nel cassetto e' dentro la parte
    // che scorre (dopo la garanzia), nella pagina carrello sotto i prodotti,
    // perche' la colonna di destra e' stretta e il carosello ci starebbe schiacciato.
    // Nella pagina carrello il cassetto esiste lo stesso, nascosto: senza questo
    // controllo il blocco finiva dentro quello e non si vedeva.
    // Nella pagina carrello l'elenco (cart-items) e' "sticky" dentro il suo form:
    // il carosello va DOPO il form, altrimenti scorrendo l'elenco gli passa sopra.
    var inPaginaCarrello = /^\/cart(\/|$)/.test(location.pathname);
    var elenco = null;
    if (inPaginaCarrello) {
      var lista = Array.prototype.filter.call(document.querySelectorAll('cart-items'), function (el) {
        return !el.closest('#CartDrawer');
      })[0] || null;
      elenco = lista ? (lista.closest('form') || lista) : null;
    } else {
      var corpo = document.querySelector('[id^="CartDrawerBody-"]');
      elenco = corpo ? corpo.querySelector('cart-items') : null;
    }
    var posto = postoIn(inPaginaCarrello);
    if (!elenco && !posto) return false;

    var box = posto || document.createElement('div');
    box.className = 'app-push' + (inPaginaCarrello ? ' app-push--pagina' : '');
    box.removeAttribute('data-app-push-posto');
    box.removeAttribute('aria-hidden');
    box.setAttribute('data-app-push', '');
    box.innerHTML = caroselloHtml(proposte);
    if (!posto) elenco.parentNode.insertBefore(box, elenco.nextSibling);
    collegaClic(box, proposte);
    collegaFrecce(box);
    return true;
  }

  // Il tema ridisegna il cassetto a ogni modifica del carrello e si porta via il
  // blocco: qui lo si rimette, ma solo se la regola vale ancora (se il cliente
  // ha tolto l'unico prodotto nostro, restano solo drop e il blocco non torna).
  // Rifacendo le scelte si tolgono dal carosello i prodotti appena aggiunti.
  // Si guarda sia il cassetto sia la pagina carrello: il tema li ridisegna tutti
  // e due quando cambia il carrello.
  var ricontrollo = null;
  function sorveglia() {
    if (osservatore) return;
    var dove = [document.getElementById('CartDrawer'), document.querySelector('[id^="MainCart-"]')]
      .filter(Boolean);
    if (!dove.length) return;
    osservatore = new MutationObserver(function () {
      // da fare solo se il ridisegno ha portato uno scheletro nuovo, o si e'
      // portato via il carosello
      var daFare = document.querySelector('[data-app-push-posto]') || !document.querySelector('[data-app-push]');
      if (!proposte || !daFare || ricontrollo) return;
      ricontrollo = setTimeout(function () {
        Promise.all([inProva() ? Promise.resolve({}) : listaDrop(), carrello(), listaPromo()]).then(function (res) {
          ricontrollo = null;
          var righe = (res[1] && res[1].items) || [];
          if (!res[0] || !ciSonoNostri(res[0], righe)) { togliPosti(); return; }
          proposte = scegli(res[2], res[1], '');
          if (!proposte.length) { togliPosti(); return; }
          inserisci();
        }).catch(function () { ricontrollo = null; togliPosti(); });
      }, 150);
    });
    dove.forEach(function (el) { osservatore.observe(el, { childList: true, subtree: true }); });
  }

  // Dopo un'aggiunta dal carosello il tema non sa niente: la chiamata e' nostra.
  // Gli si manda lo stesso evento che usa lui (cartUpdate con l'HTML delle
  // sezioni del carrello), cosi' ridisegna elenco e totale nel cassetto e nella
  // pagina carrello. Se qualcosa manca si aggiorna almeno il numerino.
  function ridisegnaCarrello() {
    var ft = window.FoxTheme;
    if (!ft || !ft.pubsub || !ft.utils || !ft.utils.getSectionId) { aggiornaConteggio(); return; }
    var ids = [];
    Array.prototype.forEach.call(document.querySelectorAll('cart-items'), function (el) {
      try {
        var id = ft.utils.getSectionId(el);
        if (id && ids.indexOf(id) < 0) ids.push(id);
      } catch (e) {}
    });
    if (!ids.length) { aggiornaConteggio(); return; }
    Promise.all([
      fetch(location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }),
      carrello()
    ]).then(function (res) {
      var c = res[1];
      c.sections = res[0];
      ft.pubsub.publish(ft.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: c });
    }).catch(function () { aggiornaConteggio(); });
  }

  // "Mostrato" solo quando il carosello si vede davvero: nella pagina carrello,
  // o nel cassetto aperto. Nel cassetto chiuso lo si prepara in anticipo e non
  // conta.
  function tracciaVisto() {
    var inPagina = /^\/cart(\/|$)/.test(location.pathname);
    var cassetto = document.querySelector('cart-drawer');
    if (!inPagina && !(cassetto && cassetto.hasAttribute('open'))) return;
    traccia('Push Carrello Mostrato', { dove: inPagina ? 'carrello' : 'cassetto', proposti: proposte ? proposte.length : 0 });
  }

  function mostra(scelti) {
    proposte = scelti;
    aperto = true;

    // il cassetto puo' aprirsi un attimo dopo l'aggiunta: si riprova per qualche secondo
    var tentativi = 0;
    (function prova() {
      if (inserisci()) { sorveglia(); tracciaVisto(); return; }
      if (++tentativi > 12) return;
      setTimeout(prova, 500);
    })();
  }

  // Il numerino del carrello nell'header: lo rileggo dal carrello vero.
  function aggiornaConteggio() {
    carrello().then(function (c) {
      var n = c && c.item_count;
      if (typeof n !== 'number') return;
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n > 99 ? '99+' : String(n); });
    });
  }

  // --- decisione -----------------------------------------------------------
  // Si guarda il carrello intero (regola di Danilo, 24/09): basta un prodotto
  // che parte dal nostro magazzino e la proposta ha senso, perche' lo sfizio
  // viaggia nel suo pacco. Se invece partono tutti dal fornitore, un pacco
  // nostro non c'e' e il blocco non esce.
  // Garanzie e servizi (consegna al piano, installazione...) sono righe del
  // carrello ma non si spediscono da sole: non contano ne' da una parte ne'
  // dall'altra. La garanzia Garanzia3 in anagrafica risulta Instock, e senza
  // questa eccezione accenderebbe il blocco su un carrello tutto in drop.
  function accessoria(riga) {
    if (riga.properties && riga.properties._parent) return true;          // servizi
    var marca = String(riga.vendor || '') + ' ' + String(riga.product_type || '');
    return /garanzia/i.test(marca) || /^garanzia/i.test(String(riga.handle || ''));
  }

  function ciSonoNostri(drop, righe) {
    for (var i = 0; i < righe.length; i++) {
      if (accessoria(righe[i])) continue;
      var idp = idProdotto(righe[i].handle);
      if (idp && !drop[idp]) return true;      // senza id riconoscibile non conta
    }
    return false;
  }

  // Niente piu' pausa se un altro popup (garanzia, consegna) si e' appena
  // chiuso: valeva per la finestra a parte, il carosello sta fermo nel cassetto
  // e con lo scheletro gia' disegnato sparirebbe e basta.
  function valutaCarrello() {
    if (aperto) return;

    var controlloDrop = inProva() ? Promise.resolve({}) : listaDrop();
    Promise.all([controlloDrop, carrello(), listaPromo()]).then(function (res) {
      var drop = res[0], c = res[1];
      var righe = (c && c.items) || [];
      // lista dei drop non disponibile: non si propone niente
      if (!drop || !righe.length || !ciSonoNostri(drop, righe)) { togliPosti(); return; }
      var scelti = scegli(res[2], c, '');
      if (!scelti.length) { togliPosti(); return; }
      mostra(scelti);
    }).catch(function () { togliPosti(); });
  }

  function valuta(handleAggiunto) {   // resta per comodita' nelle prove
    valutaCarrello();
  }

  // --- aggancio alle aggiunte al carrello ----------------------------------
  // Non si intercettano le fetch: sul tema ci sono gia' due script che
  // riavvolgono window.fetch (garanzia e servizi) e l'ultimo che arriva taglia
  // fuori gli altri. Qui si guarda il carrello vero: al clic su un pulsante di
  // aggiunta si confronta il contenuto con la foto di prima e si vede cos'e'
  // entrato. Funziona anche con l'aggiunta rapida dalle liste.
  var foto = {};      // variante -> quantita', com'era prima del clic
  var controlli = 0;

  function fotografa() {
    return carrello().then(function (c) {
      var m = {};
      ((c && c.items) || []).forEach(function (i) { m[i.variant_id] = i.quantity; });
      foto = m;
      return m;
    });
  }

  function novita() {
    return carrello().then(function (c) {
      var righe = (c && c.items) || [];
      var entrato = null;
      righe.forEach(function (i) {
        var prima = foto[i.variant_id] || 0;
        if (i.quantity > prima) entrato = i;
      });
      righe.forEach(function (i) { foto[i.variant_id] = i.quantity; });
      return entrato;
    });
  }

  function guarda() {
    if (controlli > 3) return;
    controlli++;
    novita().then(function (i) {
      if (i && i.handle) { controlli = 99; valuta(i.handle); return; }
      setTimeout(guarda, 1200);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var dentroForm = t.closest('form[action*="/cart/add"]');
    var bottone = t.closest('[name="add"], button[type="submit"], .product-card__atc, [data-quick-add], [data-add-to-cart]');
    if (!bottone || (!dentroForm && !t.closest('.product-card, [data-quick-add], [data-add-to-cart]'))) return;
    if (aperto) return;
    controlli = 0;
    setTimeout(guarda, 1000);
  }, true);

  fotografa().then(function () {
    // Con roba nel carrello si decide subito, su ogni pagina: nella pagina
    // carrello il carosello si vede, altrove si prepara nel cassetto chiuso (o
    // se ne toglie lo scheletro, se sono tutti drop), cosi' aprendolo e' pronto.
    if (document.documentElement.classList.contains('cart-has-items') || document.querySelector('.cart__footer')) {
      valutaCarrello();
    }
  });

  // Cassetto aperto dall'icona del carrello, senza un'aggiunta (Danilo, 24/09):
  // il tema mette l'attributo "open" su cart-drawer, e anche li' il carosello
  // deve esserci. Se c'e' gia' (aperto dopo un'aggiunta) non si rifa' niente.
  (function () {
    var cassetto = document.querySelector('cart-drawer');
    if (!cassetto || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!cassetto.hasAttribute('open')) return;
      if (document.querySelector('#CartDrawer [data-app-push]')) { tracciaVisto(); return; }
      aperto = false;
      valutaCarrello();
    }).observe(cassetto, { attributes: true, attributeFilter: ['open'] });
  })();

  // Con qualcosa nel carrello (il tema mette cart-has-items su <html>) i dati
  // servono di sicuro: si scaricano subito, cosi' lo scheletro si riempie prima.
  if (document.documentElement.classList.contains('cart-has-items')) {
    if (!inProva()) listaDrop();
    listaPromo();
  }

  window.__pushPopup = { valuta: valuta };
})();
